var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      staticStyle: { width: "100%" },
      attrs: {
        multiple: _vm.multiple,
        disabled: _vm.disabled,
        filterable: "",
        clearable: "",
        placeholder: _vm.placeholder,
      },
      on: { change: _vm.handleChangeTree },
      model: {
        value: _vm.valueFormatter,
        callback: function ($$v) {
          _vm.valueFormatter = $$v
        },
        expression: "valueFormatter",
      },
    },
    _vm._l(_vm._options, function (item, index) {
      return _c("el-option", {
        key: index,
        attrs: { label: item.label, value: item.value },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }